import { render, staticRenderFns } from "./TermOfUseSolarenergie.vue?vue&type=template&id=56fcd2d6&"
import script from "./TermOfUseSolarenergie.vue?vue&type=script&lang=js&"
export * from "./TermOfUseSolarenergie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports